import {useEffect, useRef, useState} from "react";

export const useAutoSize = (
    maxRows: number | undefined,
    value: string
) => {
    const textAreaRef = useRef<HTMLTextAreaElement>(null);
    const [textAreaHeight, setTextAreaHeight] = useState("auto");
    const [isOverflowAuto, setIsOverflowAuto] = useState(false);

    useEffect(() => {
        const element = textAreaRef.current;
        if (!element) return;

        const start = element.selectionStart;
        const end = element.selectionEnd;

        const savedHeight = element.style.height;
        element.style.height = "auto";

        const scrollHeight = element.scrollHeight;
        const computed = window.getComputedStyle(element);
        const lineHeight = parseInt(computed.lineHeight, 10) || 20;
        const paddingTop = parseInt(computed.paddingTop, 10) || 0;
        const paddingBottom = parseInt(computed.paddingBottom, 10) || 0;
        const borderTop = parseInt(computed.borderTopWidth, 10) || 0;
        const borderBottom = parseInt(computed.borderBottomWidth, 10) || 0;

        const verticalPadding = paddingTop + paddingBottom + borderTop + borderBottom;

        const contentHeight = scrollHeight - verticalPadding;
        const currentRows = Math.floor(contentHeight / lineHeight);
        const maxHeight = (maxRows ?? Infinity) * lineHeight + verticalPadding;

        if (maxRows && currentRows > maxRows) {
            setTextAreaHeight(`${maxHeight}px`);
            setIsOverflowAuto(true);
        } else {
            setTextAreaHeight(`${scrollHeight}px`);
            setIsOverflowAuto(false);
        }

        element.setSelectionRange(start, end);

        element.style.height = savedHeight;
    }, [value, maxRows]);

    return { isOverflowAuto, textAreaHeight, textAreaRef };
};